import request from '@/utils/request'
//公司介绍
export function companyInfo(data) {
    return request({
        url: `/Member/GetCompanyInfo`,
        method: 'post',
        data
    })
}

//头条号详情
export function companyDetail(data) {
    return request({
        url: `/Member/GetHeadLineInfo`,
        method: 'post',
        data
    })
}